import React from 'react'

function LoadingPage() {
  return (
    <div className="loading-page-bg">
      <div className="loading-text">Loading...</div>
    </div>
  )
}

export default LoadingPage